module.exports = __webpack_public_path__ + "static/media/about_us_header_image.861e3291.svg";